export const usersPermissions = {
  cae: ['Experiências', 'Empresas'],
  caeAdmin: ['Experiências', 'Empresas'],
};